/* src/app/feature-modules/session-engagement/components/passage-text/passage-text.component.css */
.lesson-text {
  font-size: 25px;
  -webkit-user-select: none;
  user-select: none;
}
/*# sourceMappingURL=passage-text.component.css.map */
